import { FC } from 'react';

export type ItalicIconProps = {};

export const ItalicIcon: FC<ItalicIconProps> = ({}) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6668 2.66663H6.66683M9.3335 13.3333H3.3335M10.0002 2.66663L6.00016 13.3333"
      stroke="#475467"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
